import {
  Box,
  Button,
  Collapse,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface Props {
  onLoginAsStudent: () => void;
  onLoginAsAdmin: () => void;
  onTestPermitBooking: () => void;
  onTestDmvAppointment: () => void;
  onPreviewEmailCode: () => void;
  onPreviewSmsCode: () => void;
  onPreviewPassword: () => void;
}

function DevelopmentOnlyLoginPreviewContent({
  onLoginAsStudent,
  onLoginAsAdmin,
  onTestPermitBooking,
  onTestDmvAppointment,
  onPreviewEmailCode,
  onPreviewSmsCode,
  onPreviewPassword,
}: Props): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <Stack width="100%" alignItems="center" sx={{ paddingTop: 0.5 }}>
      <Button
        size="small"
        color="inherit"
        onClick={() => setOpen((current) => !current)}
      >
        {open ? "Hide dev tools" : "Dev tools"}
      </Button>
      <Collapse in={open} unmountOnExit sx={{ width: "100%" }}>
        <Box
          sx={{
            width: "100%",
            boxSizing: "border-box",
            marginTop: 1,
            padding: 1.5,
            border: "1px solid",
            borderColor: "borderMuted",
            borderRadius: "10px",
            backgroundColor: "surfaceMuted",
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", marginBottom: 1 }}
          >
            Auto-login — signs in against the local emulator.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            width="100%"
          >
            <Button
              fullWidth
              size="small"
              variant="contained"
              onClick={onLoginAsStudent}
            >
              Log in as student
            </Button>
            <Button
              fullWidth
              size="small"
              variant="contained"
              onClick={onLoginAsAdmin}
            >
              Log in as admin
            </Button>
          </Stack>
          <Button
            fullWidth
            size="small"
            variant="contained"
            onClick={onTestPermitBooking}
            sx={{ marginTop: 1 }}
          >
            Test permit booking (NY student → /permit-test)
          </Button>
          <Button
            fullWidth
            size="small"
            variant="contained"
            onClick={onTestDmvAppointment}
            sx={{ marginTop: 1 }}
          >
            DMV appointment card (booked NY student → /practice-hub)
          </Button>

          <Divider sx={{ marginY: 1.5 }} />

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", marginBottom: 1 }}
          >
            Preview login screens — no code will be sent.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            width="100%"
          >
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={onPreviewEmailCode}
            >
              Email code
            </Button>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={onPreviewSmsCode}
            >
              Text code
            </Button>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={onPreviewPassword}
            >
              Password
            </Button>
          </Stack>
        </Box>
      </Collapse>
    </Stack>
  );
}

/** Excluded from production at the component boundary. */
export default function DevelopmentOnlyLoginPreview(props: Props) {
  if (process.env.NODE_ENV !== "development") return null;
  return <DevelopmentOnlyLoginPreviewContent {...props} />;
}
